import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ThoughtBubbleStepSchema = withDefaults({
  type: 'thought-bubble-step',
  fields: [
    {
      kind: 'attribute',
      name: 'elementSelector',
    },
    {
      kind: 'attribute',
      name: 'title',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'side',
    },
    {
      kind: 'attribute',
      name: 'align',
    },
    {
      kind: 'attribute',
      name: 'disableActiveInteraction',
    },
    {
      kind: 'attribute',
      name: 'order',
    },
    {
      kind: 'belongsTo',
      name: 'flow',
      type: 'thought-bubble-flow',
      options: {
        async: false,
        inverse: 'steps',
      },
    },
  ],
});

export default ThoughtBubbleStepSchema;
